import { Card } from "react-bootstrap"
import styled from "styled-components"

export const StyleCard = styled(Card)`
  border: 0;
  cursor: pointer;
  .card-body .card-title {
    font-size: 1rem;
    text-align: center;
  }
  img{
    max-height: 250px;
    object-fit: contain;
  }
  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }
`

export const SkillsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`
